<div class="attachments-container" [style.width.px]="widthAttachments">
  <ng-scrollbar *ngIf="viewAttachment?.length > 0" [style.height.px]="scrollHeight">
    <cdk-virtual-scroll-viewport ngScrollbarView smoothScroll scrollViewport [itemSize]="itemSize">
      <ng-container *cdkVirtualFor="let attach of viewAttachment; index as i">
        <div
          #attachment
          class="attachment"
          [style.width.px]="itemWidth"
          [ngClass]="{ selected: selectedIndex === i }"
          (click)="onClick(attach.item, i)"
        >
          <div class="attachment-content">
            <u-icon *ngIf="attach.icon" [model]="attach.icon" class="attachment-icon"></u-icon>
            <span *ngIf="attach.text" [ngStyle]="{ color: attach.textColor }" class="attachment-text">
              {{ attach.text }}
            </span>
          </div>
          <div class="attachment-action">
            <u-buttons
              *ngIf="downloadEnabled"
              pTooltip="Download"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              (onClick)="$event.stopPropagation(); download(attach.item)"
              type="secondary"
            >
              <u-icon [model]="{ type: 'font', value: 'icon-download2' }"></u-icon>
            </u-buttons>
            <u-buttons
              *ngIf="attach.openEnabled"
              pTooltip="Open"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              (onClick)="$event.stopPropagation(); open(attach.item)"
              type="secondary"
              class="open-icon"
            >
              <u-icon [model]="{ type: 'font', value: 'icon-launch' }"></u-icon>
            </u-buttons>
          </div>
        </div>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </ng-scrollbar>
</div>
